import 'wicg-inert';

import * as Sentry from '@sentry/browser';
import ReactDOM from 'react-dom/client';

import App from './App';
import { PayorderBackendErrorMessage } from './enums/PayorderBackendErrorMessage';
import { getLocaleAsString } from './utils/localization';

Sentry.init({
  dsn: window.payorder.SENTRY_DNS,
  environment: window.payorder.APP_ENV,
  release: `payorder-client@${process.env.REACT_APP_VERSION}`,
  ignoreErrors: [
    // Ignore chunk loading errors, mostly from recommendations.
    /ChunkLoadError/,
    // Another error from recommendations.
    'TypeError: Invalid attempt to spread non-iterable instance.',
    // Ignore handled error messages from backend.
    PayorderBackendErrorMessage.AmountAlreadyPaid,
    PayorderBackendErrorMessage.OrderHasPendingPayment,
    PayorderBackendErrorMessage.OrderDetailsNotFound,
    PayorderBackendErrorMessage.OrderIsCancelled,
    PayorderBackendErrorMessage.OrderCannotBePaidOnline,
    PayorderBackendErrorMessage.EmailAddressIsMissing,
    PayorderBackendErrorMessage.FailedToValidateToken,
    PayorderBackendErrorMessage.TaxInformationIsMissing,
    PayorderBackendErrorMessage.PayorderAggregateNotFound,
    PayorderBackendErrorMessage.BillingContactIsMissing,
    // Error from hyperapp used in the header/footer
    'TypeError: this.events.push is not a function',
    // Ignore some common network errors
    'NetworkError when attempting to fetch resource.',
    'Network request failed',
    'The network connection was lost.',
    'The request timed out.',
    // Other
    "Failed to execute 'send' on 'XMLHttpRequest': Failed to load 'https://privacyportal-eu.onetrust.com/request/v1/consentreceipts'",
    /favs\.oneweb\.ingka.com\/graphql/,
  ],
  allowUrls: [
    /https:\/\/ww[48]\.((cte|ppe)\.)?(ikea|ikeadt)\.com\/[A-Za-z]{2}\/[A-Za-z]{2}\/order\/payorder\//,
  ],
});

Sentry.configureScope((scope) => {
  scope.setTag('locale', getLocaleAsString());
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
if (root) {
  root.render(<App />);
}
